import styled from 'styled-components';
import { PropertyCardMLSLogoMixin } from '../../mixins/components/PropertyCardMLSLogoMixin';
export var StyledPropertyCardMLSLogo = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardMLSLogo",
  componentId: "c11n-8-111-1__sc-1pf6ff9-0"
})(["", ""], PropertyCardMLSLogoMixin);